var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state flex flex-col items-center justify-center text-slate-400 dark:text-slate-500"},[_c('p',{staticClass:"mb-2 md:mb-4 opacity-60"},[_c(_vm.iconComponent,{tag:"component"})],1),_c('p',{staticClass:"md:text-base font-medium opacity-60"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }